/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { PolicyProvider } from '@Policy/store';
import React, { useCallback } from 'react';
import { useExchangeOnlineHpuTargetUserGroups } from '@Policy/hooks';
import { SingleTargetUserGroups } from '@Policy/Components/SingleTargetUserGroups';
import { getExchangeTemplateConfig } from '@Policy/TemplateConfig/cfg.exchange';
import { useOrgStore } from '@Models/useOrgModel';
import { useTranslation } from 'react-i18next';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

export const ExchangeTarget = React.forwardRef((_, ref) => {
  const TargetUserGroupsExchangeOnline = useCallback(() => {
    const props = useExchangeOnlineHpuTargetUserGroups();
    return <SingleTargetUserGroups {...props} ref={ref} />;
  }, []);
  const { t } = useTranslation();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const exchangeTemplateData = getExchangeTemplateConfig(
    t,
    selectedOrgGlobalSetting,
    ''
  );
  const configData = {};
  const { orgId } = useOrgStore();
  return (
    <PolicyProvider
      template={exchangeTemplateData}
      config={configData}
      orgId={orgId}
    >
      <TargetUserGroupsExchangeOnline />
    </PolicyProvider>
  );
});
